import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import GdvAccessListComponent from "@/modules/Gdv/components/GdvAccessListComponent.vue";
import {onMounted, ref} from "vue";
import GdvAccess from "@/shared/model/GdvAccess";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiGdv from "@/modules/Gdv/api";
import {useRouter} from "vue-router";
import {useNavigationStore} from "@/modules/Navigation/store";
import {useGdvStore} from "@/modules/Gdv/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {compareStrings} from "@/shared/utils/StringUtils";


export default /*@__PURE__*/_defineComponent({
  __name: 'GdvAccessListPage',
  setup(__props) {

const _gdvAccess = ref<GdvAccess[]>([]);
const _spinner = useSpinner();
const _router = useRouter();
const _navigationStore = useNavigationStore();
const _gdvStore = useGdvStore();


async function p_init() {

  try {
    _spinner.show()
    const res = await apiGdv.list();
    if (res) {
      _gdvAccess.value = res.sort((a, b) => compareStrings(a.id, b.id));
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

function onEdit(value: GdvAccess) {
  if (value) {
    _navigationStore.currentGdvAccessId = value.id;
    _gdvStore.gdvAccess = value
    _router.push("/gdvacess/edit")
  }

}

function onCreate() {
  _gdvStore.gdvAccess = new GdvAccess();
  _router.push("/gdvacess/create")

}

function onChangePin(value: GdvAccess) {
  if (value) {
    _navigationStore.currentGdvAccessId = value.id;
    _gdvStore.gdvAccess = value
    _router.push("/gdvaccess_change_pin")
  }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "GDV Zugänge" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                ref: "btnSearch",
                "mdi-icon": "mdi-plus",
                tooltip: "Gdv-zugang anlegen",
                onClick: onCreate
              }, null, 512),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: p_init
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(GdvAccessListComponent, {
                data: _gdvAccess.value,
                onEditClicked: onEdit,
                onChangePinClicked: onChangePin
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})